import AddressForm from "@/common/components/AddressForm";
import useAddressForm from "@/common/hooks/useAddressForm";
import { AddressData } from "@/common/types/address";
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";

interface AddressSectionProps {
  establishmentCompany?: EstablishmentCompanyData;
  isPending?: boolean;
}

const AddressSection = ({ establishmentCompany, isPending }: AddressSectionProps) => {
  const addressForm = useAddressForm({
    initialAddress: establishmentCompany?.general_information?.address as AddressData,
    disabled: true,
    isLoading: isPending,
  });

  return (
    <div className="flex flex-col gap-4">
      <p className="text-[18px] font-bold">
        Endereço
      </p>

      <AddressForm
          addressForm={addressForm}
          disableFields
        />
    </div>
  );
};

export default AddressSection;
